var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.taxCardData)?_c('InnerCardInfo',{ref:"inner",attrs:{"label":_vm.localStorage.translations.pages['setting-personal_area'].sections['nalogovaya-karta'],"data":[
    {
      name: _vm.localStorage.translations.pages['setting-personal_area'].labels[
        'verhniy-uroven-zarobotnoy-platy'
      ],
      value: _vm.upper_wage_level ? _vm.$formatCurrency(_vm.upper_wage_level) + ' €' : '-',
    },
    {
      name: _vm.localStorage.translations.pages['setting-personal_area'].labels['nizhniy-protsent'],
      value: _vm.lower_percentage ? _vm.lower_percentage + ' %' : '-',
    },
    {
      name: _vm.localStorage.translations.pages['setting-personal_area'].labels['verhniy-protsent'],
      value: _vm.top_percentage ? _vm.top_percentage + ' %' : '-',
    },
  ],"images":_vm.taxCardData.image,"need-image-domain":"","editReady":_vm.editReady}},[_c('template',{slot:"edit_block"},[_vm._t("default")],2)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }